import { SET_MEDIA_LINKS, UPDATE_MEDIA_LINKS } from '../../constants';
import {
  getInstagramMediasLinksCount,
  getInstagramMediasSettings,
  getInstagramMediaLinks,
} from '../api/linksApi';

import store from '../../store';

/**
 * Get links of medias, happened when:
 * connection - done
 * media updated (load more etc...) - done
 * links modal closed - done
 */
export const getMediasLinksCount = (newMedias, isTemplate) => (dispatch) => {
  let { medias } = store.getState().appReducer;
  medias = newMedias ? newMedias : medias;

  if (medias && medias.length > 0) {
    const mediasIds = medias
      .map((media) => {
        return media.originalData.id;
      })
      .join(',');
    const mediasLinks = medias
      .map((media) => {
        return media.originalData.permalink;
      })
      .join(',');

    const buildMap = (obj) => Object.keys(obj).map((k) => [k, obj[k]]);

    return getInstagramMediasLinksCount(
      mediasIds,
      mediasLinks,
      isTemplate,
    ).then((response) => {
      let { mediaLinksMap } = store.getState().appReducer;
      const map = buildMap(response.data);
      mediaLinksMap = mediaLinksMap
        ? new Map([...mediaLinksMap, ...map])
        : new Map(map);

      dispatch({
        type: UPDATE_MEDIA_LINKS,
        payload: mediaLinksMap,
      });
    });
  }
};

/**
 * Get link settings (add user data to DB)
 * @param {*} accountType
 */
export const getLinksSettings = (accountType) => (dispatch) => {
  return getInstagramMediasSettings(accountType)
    .then((res) => res)
    .catch((err) => err);
};

const _setCorrectDefaultLinkImg = (product) => {
  const images = {
    defaultImage: require('../../../assets/expand/default_wix_img.png'),
    defaultPageImage: require('../../../assets/expand/default_wix_img_page.png'),
  };
  switch (product.type) {
    case 'product': {
      product.image_url = images.defaultImage;
      break;
    }
    case 'site_page': {
      product.image_url = images.defaultPageImage;
      break;
    }
    default: {
      product.image_url = images.defaultImage;
    }
  }
  return product;
};

export const getMediaLinks = (
  dispatch,
  mediaId,
  mediaLink,
  accessToken,
  userId,
  isBusinessApp,
  isConnected,
) => {
  getInstagramMediaLinks(
    mediaId,
    mediaLink,
    accessToken,
    userId,
    isBusinessApp,
    isConnected,
  ).then((result) => {
    result.product_links = result.product_links.map((product) => {
      if (product.image_url) {
        product.image_url = product.image_url.replace(
          'w_50,h_50',
          'w_100,h_100',
        );
        product.image_url = product.image_url.replace(
          'w_60,h_60',
          'w_100,h_100',
        );
        product.defaultImage = false;
      }
      if (!product.image_url) {
        _setCorrectDefaultLinkImg(product);
        product.defaultImage = true;
      }
      return product;
    });

    dispatch({
      type: SET_MEDIA_LINKS,
      payload: {
        mediaId,
        newData: result.product_links,
      },
    });

    return result.product_links;
  });
};
